export default "__VITE_ASSET__1njLRrrj__"